"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthMethodSettings = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const css_1 = require("@emotion/css");
const ui_1 = require("@grafana/ui");
const BasicAuth_1 = require("./BasicAuth");
const ConfigSection_1 = require("../../ConfigSection");
const types_1 = require("../types");
const defaultOptions = {
    [types_1.AuthMethod.BasicAuth]: {
        label: 'Basic authentication',
        value: types_1.AuthMethod.BasicAuth,
        description: 'Authenticate with your data source username and password',
    },
    [types_1.AuthMethod.CrossSiteCredentials]: {
        label: 'Enable cross-site access control requests',
        value: types_1.AuthMethod.CrossSiteCredentials,
        description: 'Allow cross-site Access-Control requests with your existing credentials and cookies. This enables the server to authenticate the user and perform authorized requests on their behalf on other domains.',
    },
    [types_1.AuthMethod.OAuthForward]: {
        label: 'Forward OAuth Identity',
        value: types_1.AuthMethod.OAuthForward,
        description: 'Forward the OAuth access token (and if available: the OIDC ID token) of the user querying to the data source',
    },
    [types_1.AuthMethod.NoAuth]: {
        label: 'No Authentication',
        value: types_1.AuthMethod.NoAuth,
        description: 'Data source is available without authentication',
    },
};
const AuthMethodSettings = ({ selectedMethod, mostCommonMethod, visibleMethods: visibleMethodsFromProps, defaultOptionsOverrides, customMethods, onAuthMethodSelect, basicAuth, readOnly, }) => {
    var _a, _b, _c, _d;
    const [authMethodChanged, setAuthMethodChanged] = (0, react_1.useState)(false);
    const { colors, spacing } = (0, ui_1.useTheme2)();
    const visibleMethods = (0, react_1.useMemo)(() => {
        var _a;
        return visibleMethodsFromProps !== null && visibleMethodsFromProps !== void 0 ? visibleMethodsFromProps : [
            types_1.AuthMethod.BasicAuth,
            types_1.AuthMethod.OAuthForward,
            types_1.AuthMethod.NoAuth,
            ...((_a = customMethods === null || customMethods === void 0 ? void 0 : customMethods.map((m) => m.id)) !== null && _a !== void 0 ? _a : []),
        ];
    }, [customMethods, visibleMethodsFromProps]);
    const hasSelect = visibleMethods.length > 1;
    const preparedOptions = (0, react_1.useMemo)(() => {
        var _a;
        const customOptions = (_a = customMethods === null || customMethods === void 0 ? void 0 : customMethods.reduce((acc, method) => {
            acc[method.id] = {
                label: method.label,
                value: method.id,
                description: method.description,
            };
            return acc;
        }, {})) !== null && _a !== void 0 ? _a : {};
        const preparedDefaultOptions = {};
        let k;
        for (k in defaultOptions) {
            preparedDefaultOptions[k] = Object.assign(Object.assign({}, defaultOptions[k]), defaultOptionsOverrides === null || defaultOptionsOverrides === void 0 ? void 0 : defaultOptionsOverrides[k]);
        }
        const allOptions = Object.assign(Object.assign({}, customOptions), preparedDefaultOptions);
        return visibleMethods
            .filter((method) => Boolean(allOptions[method]))
            .map((method) => {
            const option = allOptions[method];
            if (method === mostCommonMethod && hasSelect) {
                return Object.assign(Object.assign({}, option), { label: `${option.label} (most common)` });
            }
            return option;
        });
    }, [visibleMethods, customMethods, defaultOptionsOverrides, mostCommonMethod, hasSelect]);
    let selected = selectedMethod;
    if (!hasSelect) {
        selected = visibleMethods[0];
    }
    else if (selectedMethod === types_1.AuthMethod.NoAuth && mostCommonMethod && !authMethodChanged) {
        selected = mostCommonMethod;
    }
    let AuthFieldsComponent = null;
    if (selected === types_1.AuthMethod.BasicAuth && basicAuth) {
        AuthFieldsComponent = react_1.default.createElement(BasicAuth_1.BasicAuth, Object.assign({}, basicAuth, { readOnly: readOnly }));
    }
    else if (selected.startsWith('custom-')) {
        AuthFieldsComponent = (_b = (_a = customMethods === null || customMethods === void 0 ? void 0 : customMethods.find((m) => m.id === selected)) === null || _a === void 0 ? void 0 : _a.component) !== null && _b !== void 0 ? _b : null;
    }
    const title = hasSelect ? 'Authentication methods' : (_c = preparedOptions[0].label) !== null && _c !== void 0 ? _c : '';
    const description = hasSelect
        ? 'Choose an authentication method to access the data source'
        : (_d = preparedOptions[0].description) !== null && _d !== void 0 ? _d : '';
    const styles = {
        authMethods: (0, css_1.css)(Object.assign({ marginTop: spacing(2.5) }, (hasSelect && {
            padding: spacing(2),
            border: `1px solid ${colors.border.weak}`,
        }))),
        selectedMethodFields: (0, css_1.css)({
            marginTop: spacing(1.5),
        }),
    };
    return (react_1.default.createElement(ConfigSection_1.ConfigSubSection, { title: title, description: description },
        react_1.default.createElement("div", { className: styles.authMethods },
            hasSelect && (react_1.default.createElement(ui_1.Field, { label: "Authentication method" },
                react_1.default.createElement(ui_1.Select, { inputId: "auth-method-select", options: preparedOptions, value: selected, onChange: (option) => {
                        setAuthMethodChanged(true);
                        onAuthMethodSelect(option.value);
                    }, disabled: readOnly }))),
            AuthFieldsComponent && react_1.default.createElement("div", { className: styles.selectedMethodFields }, AuthFieldsComponent))));
};
exports.AuthMethodSettings = AuthMethodSettings;
//# sourceMappingURL=AuthMethodSettings.js.map